/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  FwBuild,
  ConnextUpdateResponse,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface UpdateConnextInput {
  deviceId: string;
  build: FwBuild;
  compatibleWith?: string;
  transactionId?: string;
  force?: boolean;
}
const build = (_query: DocumentNode, input: UpdateConnextInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.deviceId !== undefined ? `$deviceId: String = ${JSON.stringify(input.deviceId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.build !== undefined ? `$build: FwBuild = ${input.build}, ` : '' ) + ``+
    ( input.compatibleWith !== undefined ? `$compatibleWith: String = ${JSON.stringify(input.compatibleWith).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.transactionId !== undefined ? `$transactionId: String = ${JSON.stringify(input.transactionId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.force !== undefined ? `$force: Boolean = ${JSON.stringify(input.force).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    updateConnext(
      ${ input.deviceId !== undefined ? 'deviceId: $deviceId,' : '' } 
      ${ input.build !== undefined ? 'build: $build,' : '' } 
      ${ input.compatibleWith !== undefined ? 'compatibleWith: $compatibleWith,' : '' } 
      ${ input.transactionId !== undefined ? 'transactionId: $transactionId,' : '' } 
      ${ input.force !== undefined ? 'force: $force,' : '' }
    ){
      ...connextupdateresponse
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class UpdateConnextMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment connextupdateresponse on ConnextUpdateResponse { ... }
   */
  async execute(_query: DocumentNode, input: UpdateConnextInput): Promise<apollo.FetchResult< { updateConnext: Partial<ConnextUpdateResponse> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ updateConnext: Partial<ConnextUpdateResponse> }>({ mutation: build(_query, input) });
  }
}
